import { IGetSpecialIngredients } from './types'

export const getSpecialIngredientVars: IGetSpecialIngredients = {
  state: {
    in: ['Unpublished', 'Published'],
  },
}
